import { DROPDOWN_SIZE, DSBottomSheet, Dropdown, DropdownButton } from '@repo/design-system/index'
import { format, isDate, isValid, subMonths } from 'date-fns'
import { Dispatch, SetStateAction, useState } from 'react'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import TimePeriodPicker from '../common/Calendar/TimePeriodPicker'

interface IFilterSectionProps {
  timePeriod: number
  setTimePeriod: Dispatch<SetStateAction<number>>
  startDate: Date
  endDate: Date
  setStartDate: Dispatch<SetStateAction<Date>>
  setEndDate: Dispatch<SetStateAction<Date>>
  dropdown?: boolean
}

export const GTM_TIME_PERIOD_MAP = {
  1: 'one_month',
  3: 'three_month',
  6: 'six_month',
  12: 'one_year',
  0: 'custom',
}
const FilterSection = ({
  timePeriod,
  setTimePeriod,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  dropdown = false,
}: IFilterSectionProps) => {
  const today = new Date()

  const formatDate = (date: string | Date) => {
    if (isValid(new Date(date))) {
      return format(new Date(date), 'yyyy.M.d')
    }
  }

  const { t } = useTranslation()

  type SortOption = {
    label: string
    value: number
    name: string
  }

  const options: SortOption[] = [
    { label: t(n_caf.statistic.date_chip1), value: 1, name: 'one_month' },
    { label: t(n_caf.statistic.date_chip2), value: 3, name: 'three_month' },
    { label: t(n_caf.statistic.date_chip3), value: 6, name: 'six_month' },
    { label: t(n_caf.statistic.date_chip4), value: 12, name: 'one_year' },
    { label: t(n_caf.statistic.date_title), value: 0, name: 'custom' },
  ]

  const [sortOption, setSortOption] = useState(options[0])
  const [showBottomSheet, setShowBottomSheet] = useState<boolean>(false)

  const handleClickSearch = (timePeriodItemValue: number, start?: Date, end?: Date) => {
    setTimePeriod(timePeriodItemValue)
    if (timePeriodItemValue) {
      setStartDate(subMonths(today, timePeriodItemValue))
      setEndDate(today)
    } else if (start && end) {
      setStartDate(start)
      setEndDate(end)
    }
    setShowBottomSheet(false)
  }

  const handleClickFilter = () => {
    setShowBottomSheet(true)
  }

  if (dropdown)
    return (
      <Dropdown
        size={DROPDOWN_SIZE.SM}
        active={false}
        onClick={handleClickFilter}
        selected={sortOption}
        setSelected={setSortOption}
        className="max-w-[90px]"
      >
        <DropdownButton>{options?.find((item) => item.value === timePeriod)?.label || ''}</DropdownButton>
      </Dropdown>
    )
  else
    return (
      <div className="flex w-full justify-between items-center">
        <Dropdown
          size={DROPDOWN_SIZE.SM}
          active={false}
          onClick={handleClickFilter}
          selected={sortOption}
          setSelected={setSortOption}
          className="max-w-[90px]"
        >
          <DropdownButton>{options?.find((item) => item.value === timePeriod)?.label || ''}</DropdownButton>
        </Dropdown>
        {isDate(startDate) && isDate(endDate) && (
          <div className="Body2-14Md flex items-start justify-start text-gray-700">
            {formatDate(format(startDate as Date, 'yyyy-MM-dd'))} - {formatDate(format(endDate as Date, 'yyyy-MM-dd'))}
          </div>
        )}
        <DSBottomSheet
          id="DsBottomSheet"
          isOpen={showBottomSheet}
          setIsOpen={setShowBottomSheet}
          closeButton={null}
          closeOnDim={true}
          closeOnDrag={false}
          zIndex="100"
        >
          <TimePeriodPicker
            currentTimePeriod={timePeriod}
            start={startDate}
            end={endDate}
            onClickSearch={handleClickSearch}
          />
        </DSBottomSheet>
      </div>
    )
}

export default FilterSection
